import React from "react";
import { FormGroup, Button } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS } from "../../helpers/formGroupVariants";
import { TERTIARY, RIGHT, SUBMIT, DRAFT, SOLICITOR, } from "../../helpers/constants";
import CONTENT_STRINGS from "../../helpers/contentStrings";

const CaseForm = (props) => {
    const {
        handleCaseTypeChange,
        handleSubCaseTypeChange,
        caseTypeOptions,
        subCaseTypeOptions,
        HandleViewSubmit,
        UserRole,
        Store,
    } = props;

    if(
        Object.keys(Store.selectedApplication).length !== 0
        && Store.selectedApplication.constructor === Object
        && ( Store.selectedApplication.policyStatus !== DRAFT || (UserRole !== SOLICITOR) )
    ) {
        return (
            <form className="form-horizontal">
                <FormGroup
                    labelSize={'col-sm-3'}
                    inputSize={'col-sm-6 manageSolicitorAccount-data'}
                    label={CONTENT_STRINGS.CASE_TYPE}
                    variant={FORM_GROUP_VARIANTS.PLAIN}
                    inputProps={{
                        name: 'selectedCaseType',
                        label: Store.selectedApplication.caseTypeName,
                        required: true
                    }}
                    formGroupTestId={'new-application-CaseType'}
                />
                {Store.selectedSubCaseType 
                ?
                    <FormGroup 
                        labelSize={'col-sm-3'}
                        inputSize={'col-sm-6 manageSolicitorAccount-data'}
                        label={CONTENT_STRINGS.SUB_CASE_TYPE}
                        variant={FORM_GROUP_VARIANTS.PLAIN}
                        inputProps={{
                            name: 'selectedSubCaseType',
                            label: Store.selectedApplication.subCaseTypeName
                        }}
                        formGroupTestId={'new-application-SubCaseType'}
                    />
                :
                    null
                }
            </form>
        )
    }

    return (
        <form autoComplete={'off'} className="form-horizontal" onSubmit={HandleViewSubmit}>
            <FormGroup
                labelSize={'col-sm-3'}
                inputSize={'col-sm-6 manageSolicitorAccount-data'}
                label={CONTENT_STRINGS.CASE_TYPE}
                variant={FORM_GROUP_VARIANTS.SELECT}
                inputProps={{
                    name: 'selectedCaseType',
                    value: Store.selectedCaseType,
                    onChange: handleCaseTypeChange,
                    options: caseTypeOptions,
                    required: true
                }}
                formGroupTestId={'new-application-CaseType'}
            />
            {Store.selectedCaseType !== '' && subCaseTypeOptions.length > 1 
            ?
                <FormGroup
                    labelSize={'col-sm-3'}
                    inputSize={'col-sm-6 manageSolicitorAccount-data'}
                    label={CONTENT_STRINGS.SUB_CASE_TYPE}
                    variant={FORM_GROUP_VARIANTS.SELECT}
                    inputProps={{
                        name: 'selectedSubCaseType',
                        value: Store.selectedSubCaseType,
                        onChange: handleSubCaseTypeChange,
                        options: subCaseTypeOptions
                    }}
                    formGroupTestId={'new-application-SubCaseType'}
                />
            :
                null
            }
            {!Store.selectedApplication.draft 
            ?
                <div className={'form-group'}>
                    <div className={'col-sm-6 col-sm-offset-3'}>
                        <Button
                            type={SUBMIT}
                            label={CONTENT_STRINGS.VIEW}
                            arrowDirection={RIGHT}
                            variant={TERTIARY}
                            buttonTestId={'new-application-ViewButton'}
                        />
                    </div>
                </div>
            :
                null
            }
        </form>
    )
};

export default CaseForm;
